export default {
    OBJECT_TYPE: "Тип"
};
